/**
 * Componentes de Fascino
 * @module Plugins
 */
import * as http from './http'
import Progress from './progressbar'

export default {
    http,
    Progress
}
